export default function Legal() {
  return (
    <div className="min-h-screen bg-white pt-24" data-testid="legal-page">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-[#ECFDF5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <span className="text-[#10B981] text-sm font-semibold uppercase tracking-wider mb-4 block">Informations légales</span>
            <h1 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight mb-6" data-testid="legal-title">
              Mentions <span className="text-[#10B981]">légales</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20" data-testid="legal-content-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl">
            <div className="bg-[#ECFDF5] border border-gray-100 rounded-3xl p-8 md:p-12 space-y-12">
              {/* Éditeur du site */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">1. Éditeur du site</h2>
                <div className="text-[#1E3A5F] font-semibold space-y-2">
                  <p><strong className="text-[#1A1A1A]">Raison sociale :</strong> 0to1</p>
                  <p><strong className="text-[#1A1A1A]">Responsable de publication :</strong> Jehan Druguet</p>
                  <p><strong className="text-[#1A1A1A]">Email :</strong> jehan@0to1-agency.fr</p>
                  <p><strong className="text-[#1A1A1A]">Téléphone :</strong> 06 58 93 05 95</p>
                </div>
              </div>

              {/* Hébergement */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">2. Hébergement</h2>
                <div className="text-[#1E3A5F] font-semibold space-y-2">
                  <p>Le site est hébergé par :</p>
                  <p><strong className="text-[#1A1A1A]">Emergent Agent</strong></p>
                  <p>Site web : emergentagent.com</p>
                </div>
              </div>

              {/* Propriété intellectuelle */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">3. Propriété intellectuelle</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive de 0to1, à l'exception des éléments provenant de partenaires. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de 0to1.
                </p>
              </div>

              {/* Données personnelles */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">4. Protection des données personnelles</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed mb-4">
                  Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
                </p>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed mb-4">
                  Les informations recueillies via le formulaire de contact sont destinées uniquement à 0to1 dans le but de répondre à vos demandes. Elles ne sont en aucun cas transmises à des tiers.
                </p>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  Pour exercer vos droits ou pour toute question relative à la protection de vos données, vous pouvez nous contacter à : <a href="mailto:jehan@0to1-agency.fr" className="text-[#10B981] hover:underline">jehan@0to1-agency.fr</a>
                </p>
              </div>

              {/* Cookies */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">5. Cookies</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  Ce site utilise des cookies techniques nécessaires à son bon fonctionnement. Ces cookies ne collectent pas de données personnelles à des fins publicitaires. En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de ces cookies.
                </p>
              </div>

              {/* Limitation de responsabilité */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">6. Limitation de responsabilité</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  0to1 s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, 0to1 ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site et décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur ces informations.
                </p>
              </div>

              {/* Droit applicable */}
              <div>
                <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">7. Droit applicable</h2>
                <p className="text-[#1E3A5F] font-semibold leading-relaxed">
                  Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français compétents.
                </p>
              </div>

              {/* Date de mise à jour */}
              <div className="pt-8 border-t border-gray-200">
                <p className="text-[#9CA3AF] text-sm">
                  Dernière mise à jour : Janvier 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
